import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CoreApiService } from '../../../core/service/core-api-service';
import { AppService } from '../../../core/service/app.service';
import { ConfirmationService } from 'primeng/api';
import { properties } from '../../../../environments/properties';
import { JsonRequest } from '../../../model/jsonRequest.model';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-list-publicity',
  standalone: true,
  imports: [
    TableModule,
    ButtonModule,
    DividerModule,
    CommonModule,
    CalendarModule,
    FormsModule,
    TooltipModule,
    InputSwitchModule,
    DialogModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    ConfirmDialogModule,
    RouterLink,
  ],
  templateUrl: './list-publicity.component.html',
  styleUrl: './list-publicity.component.css',
})
export class ListPublicityComponent implements OnInit {
  titulo: string = 'Lista de Publicidades';
  dateStart: Date = new Date();
  dateEnd: Date = new Date();
  dateStartEdit = new Date();
  dateEndEdit = new Date();
  ltsPublicities: any[] = [];
  ltsStates: any[] = [];
  selectedState: any = null;
  selectedPublicity: any = null;
  dialogEdit: boolean = false;
  tituloDialog: string = '';

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.dateStart.setDate(this.dateEnd.getDate() - 10);
    this.getListPoliticalDivision();
  }

  getListPublicities(): void {
    if (!this.selectedState) {
      this.util.mostrarToast(
        'Lista de publicidades',
        'Debe seleccionar un estado',
        4,
      );
      return;
    }
    console.log(this.selectedState);
    const body: JsonRequest = {
      data: JSON.stringify({
        pub_state_id: this.selectedState,
        pub_date_start: this.dateStart?.toISOString().split('T')[0],
        pub_date_end: this.dateEnd?.toISOString().split('T')[0],
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceListPublicities,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsPublicities = [];
          this.ltsPublicities = data.data;
        } else {
          this.util.mostrarToast(
            'Lista de publicidades',
            'Error al obtener la lista de publicidades',
            4,
          );
        }
      },
    );
  }

  getListPoliticalDivision(): void {
    this.apiService.consumirWSGet(
      properties.servicePoliticalDivisions,
      null,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.ltsStates = data.data;
        } else {
          this.util.mostrarToast(
            'Lista de Estados',
            'Error al obtener la lista de estados',
            4,
          );
        }
      },
    );
  }

  cambiarEstado(publicity: any) {
    const body: JsonRequest = {
      data: publicity,
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceUpdatePublicity,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.util.mostrarToast(
            'Lista de publicidades',
            'Cambios guardados',
            1,
          );
        } else {
          this.util.mostrarToast(
            'Lista de publicidades',
            'Error al obtener la lista de publicidades',
            4,
          );
        }
      },
    );
  }
  openDialog(publicity: any): void {
    this.selectedPublicity = publicity;
    this.dateEndEdit.setDate(this.dateStartEdit.getDate() + 10);
    this.dialogEdit = true;
    this.tituloDialog = 'Editar Fechas de publicación';
  }

  cancelDialog(): void {
    this.dialogEdit = false;
  }
  updatePublicity() {
    if (this.dateStartEdit && this.dateEndEdit) {
      if (this.dateEndEdit <= this.dateStartEdit) {
        this.util.mostrarToast(
          'Error al Guardar',
          'La fecha fin debe ser mayor a la fecha inicio',
          4,
        );
        return;
      }
    }

    this.selectedPublicity.pub_date_start = this.dateStartEdit
      ?.toISOString()
      .split('T')[0];
    this.selectedPublicity.pub_date_end = this.dateEndEdit
      ?.toISOString()
      .split('T')[0];
    const body: JsonRequest = {
      data: this.selectedPublicity,
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceUpdatePublicity,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          this.util.mostrarToast(
            'Lista de publicidades',
            'Registro Guardado',
            1,
          );
          this.cancelDialog();
          this.getListPublicities();
        } else {
          this.util.mostrarToast(
            'Lista de publicidades',
            'Error al obtener la lista de publicidades',
            4,
          );
        }
      },
    );
  }
}
